<!--SWITCH TAB--->
<div class="middle-panel hidelg">
    <ul uk-tab class="swtitch-tab">
        <li><a [routerLink]="['/']">Exclusive</a></li>
        <li><a [routerLink]="['/standard']">Experiences</a></li>
    </ul>
</div>

<!--CENTER SLIDER-->
<section class="center-slider-wrp video-img-slider mt-8 center-full-slider-m" *ngIf="responseReceived">
    <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1" uk-slider="center: true">

        <ul class="uk-slider-items uk-grid-match">

            <li class="uk-width-3-4" *ngFor="let banner of banners">
                <a href="{{banner.banner_url}}">
                    <div class="uk-panel">
                        <picture>
                            <source media="(max-width:767px)" srcset="{{banner.banner_file_mobile}}">
                            <source media="(min-width:768px)" srcset="{{banner.banner_file_desktop}}">
                            <img data-src="{{banner.banner_file_desktop}}" alt="" class="img-width" uk-img>
                        </picture>
                    </div>
                </a>
            </li>
        </ul>

        <a class="uk-position-center-left uk-position-small" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
        <a class="uk-position-center-right uk-position-small" href="#" uk-slidenav-next uk-slider-item="next"></a>
    </div>
</section>

<!--Loader-->
<!-- <section class="center-slider-wrp video-img-slider mt-8 center-full-slider-m" *ngIf="!responseReceived">
    <div class="uk-position-relative uk-visible-toggle uk-light" tabindex="-1" uk-slider="center: true">
        <ul class="uk-slider-items uk-grid-match">
            <li class="uk-width-3-4" *ngFor="let banner of [1,2,3,4]">
                <ngx-skeleton-loader animation="progress" appearance="line"></ngx-skeleton-loader>
            </li>
        </ul>
    </div>
</section> -->